import { Button } from '@mantine/core';

export default Button.extend({
  defaultProps: {
    size: 'md',
  },
  styles: (theme) => ({
    section: {
      marginRight: theme.spacing.md,
    },
  }),
});
